import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import man from '../../assets/images/dashboard/1.png';
import Swal from "sweetalert2";
import { fetchLoginApi,  fetchRegisterApi } from '../../Apis/Login';
import { fetchOtpVerificationApi, getCityList, getCorporateList, getCountryList, getStateList, ProfileUpdateOtpRequest, profileOtpConfirm } from '../../Apis/Setting';
 import { getUserInfo } from '../../Apis/Setting';
 import Loader from '../../Modules/Settings/Loader';
 import Select from 'react-select';
import axios from 'axios';
import { uniqueToken, GpsBaseURL } from '../../api/DataApis';
import Corporate from '../../Modules/Corporate/Corporate';

const Profile = () => { 
    const [value, setValue] = useState(
        localStorage.getItem('profileURL' || man)
      );
      const [name, setName] = useState(
        localStorage.getItem('Name')
      );
      
      const [isLogin, setIsLogin] = useState(true);
      const [mobileNumber, setMobileNumber] = useState("");
      const [showOtpPopup, setShowOtpPopup] = useState(false);
      const [otp, setOtp] = useState("");
      const [loadingLogin, setLoadingLogin] = useState(false);
      const [loadingOtp, setLoadingOtp] = useState(false);
      const [Name, setNames] = useState("");
      const [PinCode, setPincode] = useState("");
      const [Email, setEmail] = useState("");
      const [Address, setAddress] = useState("");
      const [Country, setCountry] = useState(null);
      const [state, setState] = useState("");
      const [city, setCity] = useState("");
      const [BCAgentID, setBCAgentID] = useState("");
      const [BcCorporateName, setBcCorporateName] = useState("");
      const [BCCorporateID, setBCCorporateID] = useState(null);
      const [CorporateID, setCorporateID] = useState("");
      const [companies, setCompanies] = useState([]);
      const [password, setPassword] = useState('');
      const [usertype, setusertype] = useState('');
      const [countriesList, setcountriesList] = useState([]);
      const [stateList, setstateList] = useState([]);
      const [cityList, setcityList] = useState([]);
      const [corporateList, setCorporateList] = useState([]);
      const [loading, setLoading] = useState(false);
      const [DistrictName, setDistrictName] = useState("");
      const [UserData, setUserData] = useState([]);
      const [loadings, setLoadings] = useState(false);
      const [verifying, setVerifying] = useState(false);
      const [isVerified, setIsVerified] = useState(false);
      const [originalMobileNumber, setOriginalMobileNumber] = useState("");
      const handleMobileNumberChange = (e) => setMobileNumber(e.target.value);
      const handlePasswordChange = (e) => setPassword(e.target.value);
      const handleUsertypeChange = (e) => setusertype(e.target.value);
    
      const history = useNavigate();
      console.log("cityListttt", cityList);


      useEffect(() => {
        const fetchCompanies = async () => {
            try {
              const res = await axios.get(`${GpsBaseURL}/web/setting/companies`);
              const options = res.data?.data?.map((item) => ({
                value: item._id,
                label: item.company_name,
              }));
              setCompanies(options);
            } catch (error) {
              console.error("Error fetching companies:", error);
            }
        };

        fetchCompanies();
      }, []);


      const VerifyMobile = async (mobile) => {
        setVerifying(true);
        try {
          const data = await ProfileUpdateOtpRequest(mobile);
          console.log("Mobile Verification Response:", data);
          if( data?.statusCode == 200 ) {
            // 📌 Step 2: Show OTP Input Popup
            Swal.fire({
              title: "Enter OTP",
              input: "text",
              inputPlaceholder: "Enter the OTP sent to your mobile",
              showCancelButton: true,
              confirmButtonText: "Verify OTP",
              preConfirm: (otpInput) => {
                if (!otpInput) {
                  Swal.showValidationMessage("Please enter the OTP.");
                }
                return otpInput;
              },
            }).then((result) => {
              if (result.isConfirmed) {
                handleOtpSubmit(result.value); // 📌 Step 3: Call OTP Verification API
              }
            });
          } else {
            Swal.fire("Error", data?.message, "error");
          }

        } catch (error) {
          console.error("Error verifying mobile:", error);
          Swal.fire("Error", "Failed to send OTP. Try again.", "error");
        } finally {
          setVerifying(false);
        }
      };
      document.title = "Profile";
    
      // 📌 Step 3: Verify OTP
      const handleOtpSubmit = async (enteredOtp) => {
        if (!enteredOtp) {
          Swal.fire("Error", "Please enter the OTP.", "error");
          return;
        }
    const data = {
      "otp" : enteredOtp,
      "mobile" : mobileNumber
    }
        setLoadingOtp(true);
        try {
          const response = await profileOtpConfirm(data);
          console.log("OTP Verification Response:", response);
    
          if (response?.statusCode === 200) {
            setIsVerified(true);
            Swal.fire("Success", response?.message, "success");
          } else {
            Swal.fire("Error", `${response.message}`, "error");
          }
        } catch (error) {
          console.error("Login Error:", error);
          Swal.fire("Error", "OTP Verification Failed. Try again.", "error");
        } finally {
          setLoadingOtp(false);
        }
      };
    

      const handleLogin = async (event) => {

        event.preventDefault(); // Prevent page reload
        
        if (mobileNumber !== originalMobileNumber && !isVerified) {
          Swal.fire("Error", "Please verify your new mobile number before updating.", "error");
          return;
        }
        try {
          setLoadings(true);
      {
    
            // ✅ Signup Flow
            const userData = {
              name: Name,
              email: Email,
              address: Address,
              country: Country,
              mobile : mobileNumber,
              state: state,
              city: city,
              pin_code: PinCode,
              bc_agent_id: BCAgentID,
              corporate_id: CorporateID,
              district: DistrictName,
              bc_corporate_name: BcCorporateName,
              company_id:BCCorporateID
            };
    
            const response = await fetchRegisterApi(userData);
            console.log("Signup Response:", response);
    
            if (response?.statusCode === 200) {
              Swal.fire({
                icon: "success",
                title: "Success",
                text:  response?.message || "Please try again1.",
              });

              // window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`;
              setShowOtpPopup(true);
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text:  response?.message || "Please try again1.",
              });
            }
          }
        } catch (error) {
          console.error("Error:", error);
    
          // Extract and format error messages
          let errorMessage = "An error occurred. Please try again.";
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            errorMessage = Array.isArray(errorData.message)
              ? errorData.message.join("\n")
              : errorData.message || errorMessage;
          }
    
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: errorMessage,
          });
        } finally {
          setLoadingLogin(false);
          setLoadings(false);
        }
      };
    
      useEffect(() => {
      
        const token = localStorage.getItem("authtoken");
    
        if (token) {
          // Redirect to dashboard if token exists
          // window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`;
        }
      }, []);
    
    
    
    
      const fetchCorporatesList = async () => {
        try {
          const corporatesData = await getCorporateList();
          console.log("corporateData", corporatesData);
          setCorporateList(corporatesData?.data || []);
        } catch (error) {
          console.error("Error fetching classes:", error);
        }
      };
      useEffect(() => {
        fetchCorporatesList();
      }, []);
      
    
  
      const fetchUserList = async () => {
        setLoading(true);
    
        try {
            const userData = await getUserInfo();
            console.log("userData", userData?.data);
            setUserData(userData?.data);
        } catch (error) {
            console.error("Error fetching user list:", error);
        } finally {
            setLoading(false); // Ensures loading is set to false even if an error occurs
        }
    };
    
      // setStatusListing(res.data);
      useEffect(() => {
        fetchUserList();
      }, []);

    const fetchCountriesList = async () => {
    
        try {
          const countriesData = await getCountryList();
          console.log("countriesData", countriesData?.data);
          setcountriesList(countriesData?.data);
        } catch (error) {
          console.error("Error fetching classes:", error);
        }
      };
      // setStatusListing(res.data);
      useEffect(() => {
        fetchCountriesList();
      }, []);
      
      const fetchStateList = async () => {
        if (!Country?.id) {
          console.log("Country ID is missing, cannot fetch state.");
          return;
        }
    console.log("country ID inside state Function",Country?.id )
        try {
          const stateData = await getStateList(Country?.id);
          setstateList(stateData?.data?.data || []);
        } catch (error) {
          console.error("Error fetching classes:", error);
        }
      };
      // setStatusListing(res.data);
      useEffect(() => {
        fetchStateList();
      }, [Country]);

      
    
    
    
      const fetchCityList = async () => {
        if (!state?.id) {
          console.log("State ID is missing, cannot fetch cities.");
          return;
        }
      

        try {
          console.log("stateID inside city Function", state);
          const cityData = await getCityList(state?.id);
          console.log("cityData-testing", cityData);
          setcityList(cityData?.data?.data || []);
        } catch (error) {
          console.error("Error fetching classes:", error);
        }
      };
      // setStatusListing(res.data);
      useEffect(() => {
        if (state?.id) {
          fetchCityList();
        }
      }, [state]);
      

      useEffect(() => {
        // setLoading(true);
        if (UserData) {
         setNames(UserData?.name || "");

         setEmail(UserData?.email || "");
         setMobileNumber(UserData?.mobile|| "")
         setOriginalMobileNumber(UserData?.mobile || "");
         setPincode(UserData?.pin_code);
         setDistrictName(UserData?.district);
         if(UserData?.corporate_id) {
          setCorporateID(UserData?.corporate_id[0]|| [])
         }
         setBCAgentID(UserData?.bc_agent_id|| "");
         setBcCorporateName(UserData?.bc_corporate_name|| "");
         console.log("UserData?.company_id", UserData?.company_id);
         if(UserData?.company_id) {
          setBCCorporateID(UserData?.company_id[0] || []);
         }
         setAddress(UserData?.address);
         if (UserData?.countryId) {
           const countryId = UserData.countryId[0] || "";
           
           // Find the country in `countriesList` based on `_id`
           const matchedCountry = countriesList?.find((c) => c._id === countryId);
           
           setCountry({
             id: matchedCountry?.id || "",  // Get `id` from `countriesList`
             _id: countryId                  // Use `_id` from `UserData`
           });
         }
         
        if(UserData?.stateId) {
         const stateId = UserData.stateId[0] || "";
         console.log("stateId matched", stateId);
         const matchedState = stateList?.find((c) => c._id === stateId);
         console.log("matchedState", matchedState);
         setState({ id : matchedState?.id, _id : stateId || ""})
        }

      if(UserData?.cityId) {
        //console.log("UserData?.cityId", UserData?.cityId[0]);
         setCity( UserData?.cityId[0]|| "")
      }
          // Set loading to false once data is loaded
          // setLoading(false);
        }
      }, [UserData, countriesList,]);

      
    
    
    
      const handlecountryChange = (e) => {
        const selectedCountryId = e.target.value;
        const selectedCountry = countriesList.find((c) => c._id === selectedCountryId);
        setCountry(selectedCountry); // ✅ Store the entire country object
      };
      
      const handlestateChange = (e) => {
        const selectedStateId = e.target.value;
        const selectedState = stateList?.find((c) => c._id === selectedStateId);
        setState(selectedState); // ✅ Store the entire country object
      };
    
      
     console.log("userData", UserData);
     console.log("stateList", stateList);
    return (
        <>
     {loading ? (
    <Loader />
  ) : (
      <div className="product-container">
                <div className="container">
                    <div className="px-5 py-3">
                        <h2 className="text-3xl font-bold mb-1">Profile Settings</h2>
                        <p className="text-gray-600 text-sm">Update your personal information and preferences</p>
                        <div className="profile-box mt-3">
                            <form className="login-form12 login-box">
                                <div className='row'>
                                    <div className="col-lg-6 col-md-8 col-12">
                                        <div className='row'>
                                            <div className="col-12 form-group">
                                                <label htmlFor="fullName">Full Name <span style={{ color: "red" }}>*</span></label>
                                                <input className='form-control' type="text" id="fullName" placeholder="Enter your full name" value={Name} onChange={(e) => setNames(e.target.value)} />
                                            </div>

                                            <div className="col-12 form-group">
                                                <label htmlFor="email">Email <span style={{ color: "red" }}>*</span></label>
                                                <input className='form-control' type="email" id="email" placeholder="Enter your email" value={Email} onChange={(e) => setEmail(e.target.value)} />
                                            </div>

                                            <div className='col-12 form-group'>
                                                <label htmlFor="email">Mobile Number <span style={{ color: "red" }}>*</span></label>
                                                <div className='row'>
                                                    <div className='col-9'>
                                                        <input
                                                            className='form-control'
                                                            id="text"
                                                            type="text"
                                                            placeholder="Enter Mobile Number"
                                                            name="text"
                                                            value={mobileNumber}
                                                            onChange={handleMobileNumberChange}
                                                            
                                                        />
                                                    </div>
                                                 
                                                    <div className='col-3'>
                                                    <button
        type="button"
        onClick={() => VerifyMobile(mobileNumber)}
        className="btn btn--form update-profile-btn mob-verify-btn w-100"
        disabled={verifying || isVerified} // ✅ Disable button if already verified
      >
        {isVerified ? "Verified" : verifying ? "Verifying..." : "Verify"}
      </button>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 form-group">
                                                <label htmlFor="corporate">Corporate</label>
                                                <select className='form-control' id="corporate"  value={CorporateID}  disabled={CorporateID ? true : false} onChange={(e) => setCorporateID(e.target.value)} >
                                                    <option value="">Select Corporate</option>
                                                    {corporateList.map((u) => (
                                                        <option key={u._id} value={u._id}>{u.corporate_name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-12 form-group">
                                                <label htmlFor="bcAgentID">BC Agent ID<span style={{ color: "red" }}>*</span></label>
                                                <input className='form-control' type="text" id="bcAgentID" placeholder="Enter BC Agent ID" value={BCAgentID} onChange={(e) => setBCAgentID(e.target.value)} />
                                            </div>
                                            
                                            <div className="col-12 form-group">
                                              <Select
                                                id="bcCorporateName"
                                                className="form-control"
                                                options={companies}
                                                value={companies.find((opt) => opt.value === BCCorporateID)} // ✅ match by value
                                                onChange={(selected) => {
                                                  setBCCorporateID(selected?.value || "");
                                                }}
                                                placeholder="Select BC Corporate Name"
                                                isClearable
                                                isDisabled={!!BCCorporateID} // ✅ disables if not empty
                                              />
                                            </div>

                                            {BCCorporateID === "686040c4ec7443e4d4d9348f" && (
                                              <div className="col-12 form-group">
                                                <label htmlFor="customCorporateName">Enter BC Corporate Name</label>
                                                <input
                                                  type="text"
                                                  id="customCorporateName"
                                                  className="form-control"
                                                  placeholder="Enter BC Corporate Name"
                                                  value={BcCorporateName}
                                                  onChange={(e) => setBcCorporateName(e.target.value)}
                                                />
                                              </div>
                                            )}

                                            <div className="col-12 form-group">
                                                <label htmlFor="country">Country<span style={{ color: "red" }}>*</span></label>
                                                <select
                                                  className="form-control"
                                                  id="country"
                                                 value={Country?._id || ""} // ✅ Ensure value is an `_id`
                                                onChange={handlecountryChange}
                                                 >
                                               <option value="">Select Country</option>
                                                {countriesList?.map((u) => (
                                               <option key={u._id} value={u._id}>
  {u.name}
                                                  </option>
                                                   ))}
                                                   </select>


                                            </div>
                                            <div className='col-12 mt-4 mb-3'>
                                                <div className='text-lg font-medium'>Address Details</div>
                                            </div>
                                            <div className="col-12 form-group mb-4">
                                                <label htmlFor="address">Address<span style={{ color: "red" }}>*</span></label>
                                                <textarea className='form-control text-start' id="address" placeholder="Enter your address" value={Address} onChange={(e) => setAddress(e.target.value)} />
                                            </div>
                                            <div className="col-md-6 col-12 form-group">
                                                <label htmlFor="state">State<span style={{ color: "red" }}>*</span></label>
                                                <select className='form-control' id="corporate" value={state?._id} onChange={handlestateChange}>
                                                    <option value="">Select State</option>
                                                    {stateList?.map((u) => (
                                                        <option key={u._id} value={u._id}>
                                                            {u.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div className="col-md-6 col-12 form-group">
                                                <label htmlFor="city">City<span style={{ color: "red" }}>*</span></label>
                                                <select className='form-control' id="city" value={city} onChange={(e) => setCity(e.target.value)} >
                                                    <option value="">Select City</option>
                                                    {cityList?.map((u) => (
                                                        <option key={u._id} value={u._id}>{u.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                                 <div className="col-12 form-group">
                                                <label htmlFor="pinCode">Pin Code<span style={{ color: "red" }}>*</span></label>
                                                <input className='form-control' type="number" id="pinCode" placeholder="Enter your pin code" value={PinCode} onChange={(e) => setPincode(e.target.value)} />
                                            </div>
                                            <div className="col-12 form-group">
                                                <label htmlFor="pinCode">Disctrict<span style={{ color: "red" }}>*</span></label>
                                                <input className='form-control' type="text" id="district_name" value={DistrictName} placeholder="Enter your District" onChange={(e) => setDistrictName(e.target.value)} />
                                            </div>
                                        </div>
                                        <button onClick={handleLogin} className="btn btn--form w-100" disabled={loadings}> {loadings ? <span className="spinner-border spinner-border-sm me-2" style={{width: "1.2rem", height:"1.2rem", borderWidth:"0.15rem", verticalAlign:"-4px"}} role="status" aria-hidden="true"></span> : "Update Profile"}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
          )}
</>
    )
}

export default Profile